module.exports = __webpack_public_path__ + "static/media/drums-head.d1e9e0c3.jpg";